(function (ws, global) {
    'use strict';
    /**
     * @typedef {Object} Event - DOM Event object
     */
    ws.views.sessionTimeoutModal = ws.views.modal.extend({

        GTM_EVENT_CATEGORY: 'user',
        GTM_EVENT_ACTION: 'logout_overlay',
        GTM_STAY_EVENT_LABEL: 'stay_loggedin',
        GTM_SHOW_EVENT_LABEL: 'impression',

        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .login': 'stayLoggedIn',
            'click .logout': 'logoutUser'
        }),

        /**
         * Initialize
         */
        initialize: function () {
            ws.views.modal.prototype.initialize.call(this);

            this.sessionTimeOutInSeconds = global.sessionTimeOut;

            this.$countdownTimer = this.$('.sst-countdown');
            this.$counterMessage = this.$('.sst-counter');
            this.$sessionExpiredMessage = this.$('.sst-expired');
            this.$stayloggedInbutton = this.$('.login');
            this.logoutUrl = $('.comp-logout a').attr('href');
            this.$modalOverlaySession = $('.modal-overlay-session-timeout');

            this.timeout = undefined;
            this.countDownInterval = undefined;

            $(document).on('click', this.resetTimer.bind(this));

            this.beginSessionTimeoutCountdown();
        },

        /**
         * Reset time when not clicking inside modal
         * @param {Object} e
         */
        resetTimer: function(e) {
            // Avoid reset if any part of the modal was clicked.
            var $clickedEl = $(e.target);
            var modalClicked = $.merge($clickedEl, $clickedEl.parents()).hasClass('session-timeout-modal');
            if (!modalClicked) {
                this.beginSessionTimeoutCountdown();
            }
        },

        /**
         * Begin session timeout countdown
         */
        beginSessionTimeoutCountdown: function() {
            var fiveMinutesInSeconds = 300;
            var timeOutDurationInMilliseconds = (this.sessionTimeOutInSeconds - fiveMinutesInSeconds) * 1000;

            if (this.timeout) {
                clearTimeout(this.timeout);
            }

            if (this.countDownInterval) {
                this.$countdownTimer.html('5:00');
                clearTimeout(this.countDownInterval);
            }

            this.timeout = setTimeout(function() {
                this.$sessionExpiredMessage.hide();
                this.$counterMessage.show();
                this.$stayloggedInbutton.show();
                this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, this.GTM_SHOW_EVENT_LABEL);
                _satellite.track('event:user:logout:overlay');
                this.onOpen();

                //only render second overlay if there's already a modal visible
                if (westcon.modalInQueue > 0 && this.$modalOverlay.hasClass('show')) {
                    this.$modalOverlaySession.addClass('show');
                }

                this.countdown();

            }.bind(this), timeOutDurationInMilliseconds);
        },

        /**
         * 5 minute countdown in modal
         */
        countdown: function() {
            var duration = moment.duration(5, 'minutes');
            var interval = 1000;

            this.countDownInterval = setInterval(function () {
                duration = moment.duration(duration - interval, 'milliseconds');
                this.$countdownTimer.html(duration.minutes() + ':' + ('0' + duration.seconds()).slice(-2));
                if (duration.minutes() === 0 && duration.seconds() === 0) {
                    this.sessionExpired();
                    clearInterval(this.countDownInterval);
                }
            }.bind(this), interval);
        },

        /**
         * Update modal UI when session has expired
         */
        sessionExpired: function() {
            this.$sessionExpiredMessage.show();
            this.$counterMessage.hide();
            this.$stayloggedInbutton.hide();
        },

        /**
         * Redirect to logout page
         */
        logoutUser: function() {
            window.location.href = this.logoutUrl;
        },

        /**
         * Keep user logged in
         */
        stayLoggedIn: function() {
            this.gtmEventTracking(this.GTM_EVENT_CATEGORY, this.GTM_EVENT_ACTION, this.GTM_STAY_EVENT_LABEL);
            this.$modalOverlaySession.removeClass('show');
            this.onClose(true);
        }
    });
})(westcon, window);
